import { createSubstore } from 'storeon-substore';
import type { Store } from 'store/types';
import { requestShopList } from './shops-actions';
import { FETCH_SHOP_LIST, SHOPS_STORE_NAME } from './shops-constants';
import { ShopsStore } from './shops-types';

const INITIAL_STATE: ShopsStore = {
  shopList: null,
  error: null,
  loading: false,
} as const;

export const shops = (parentStore: Store) => {
  const store = createSubstore(parentStore, SHOPS_STORE_NAME);
  store.on('@init', () => INITIAL_STATE);
  store.on(FETCH_SHOP_LIST.init, async () => {
    const { loading } = store.get();
    const { modelJson, orchestratorHost, useCredentials, apiKey, requestID } = parentStore.get();

    if (!modelJson.model || !orchestratorHost || loading) {
      return Promise.resolve();
    }

    store.dispatch(FETCH_SHOP_LIST.request);

    try {
      const shopList = await requestShopList(modelJson.model.properties.regionId, {
        orchestratorHost,
        useCredentials,
        apiKey,
        requestID,
      });
      store.dispatch(FETCH_SHOP_LIST.success, shopList);
    } catch (e) {
      store.dispatch(FETCH_SHOP_LIST.failure, 'Не удалось загрузить список магазинов');
    }

    return Promise.resolve();
  });
  store.on(FETCH_SHOP_LIST.request, state => ({ ...state, loading: true }));
  store.on(FETCH_SHOP_LIST.failure, (_, error) => ({ error, shopList: null, loading: false }));
  store.on(FETCH_SHOP_LIST.success, (_, res) => ({ shopList: res, error: null, loading: false }));
};
